export const copy = [
  '0 0 32 32',
  `
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.8286" stroke="#000" d="M27.067 11.85h-12.45c-1.528 0-2.767 1.239-2.767 2.767v12.45c0 1.528 1.239 2.767 2.767 2.767h12.45c1.528 0 2.767-1.239 2.767-2.767v-12.45c0-1.528-1.239-2.767-2.767-2.767z"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.8286" stroke="#000" d="M6.317 20.15h-1.383c-0.734 0-1.438-0.292-1.956-0.81s-0.81-1.222-0.81-1.956v-12.45c0-0.734 0.291-1.438 0.81-1.956s1.223-0.81 1.956-0.81h12.45c0.734 0 1.437 0.292 1.956 0.81s0.81 1.223 0.81 1.956v1.383"></path>

`,
]
